import * as React from 'react';
import styled from '../../styled-components';
export const LogoImgEl = styled.img.withConfig({
  displayName: "styledelements__LogoImgEl",
  componentId: "sc-1kr0ty4-0"
})(["max-height:", ";max-width:", ";padding:", ";width:100%;display:block;"], props => props.theme.logo.maxHeight, props => props.theme.logo.maxWidth, props => props.theme.logo.gutter);
export const LogoWrap = styled.div.withConfig({
  displayName: "styledelements__LogoWrap",
  componentId: "sc-1kr0ty4-1"
})(["text-align:center;"]);
const Link = styled.a.withConfig({
  displayName: "styledelements__Link",
  componentId: "sc-1kr0ty4-2"
})(["display:inline-block;"]);
export const LinkWrap = url => Component => <Link href={url}>{Component}</Link>;